export default {
  doLoadItem (id = null) {
    this.loading = true
    this.$resource.get(id, { includes: this.includes })
      .then(({data}) => {
        this[this.entity] = this.prepareShow(data)
        this.afterPrepareShow()
        this.loading = false
      }).catch((error) => {
        this.loading = false
        this.afterFailure(error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/crud/form/resources/methods.js